import {
  useContactDetailsData,
  useContactDetailsState,
} from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/context';
import { CreditUsageType } from '@aibees/shared/definition';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Button, CircularProgress } from '@mui/material';
import { memo } from 'react';
import { CreditRuleCoin } from '../credit-rule-coin';
import * as Styled from './styles';
import * as SX from './sx';
import type { UnlockProfileDetailsProps as Props } from './types';

export const UnlockProfileDetails = memo(({ className }: Props) => {
  const hover = useBoolean(false);
  const unlockButtonTitle = 'Unlock All';

  const { loading, failed, unlocked } = useContactDetailsState();
  const {
    handleEnrichContactDetails,
    hasUpdates,
    unlockableItems,
    hasJobChange,
  } = useContactDetailsData();

  const handleUnlock = () => {
    handleEnrichContactDetails({});
    hover.onFalse();
  };

  const handleUpdate = () => {
    handleEnrichContactDetails({
      updateMode: true,
      updateJobChangeMode: hasJobChange,
    });
    hover.onFalse();
  };

  const handleMouseLeave = () => {
    hover.onFalse();
  };

  const handleMouseEnter = () => {
    hover.onTrue();
  };

  return (
    <Styled.Wrapper
      className={classnames('UnlockProfileDetails', className)}
      sx={SX.root}
    >
      {hover.value && !loading && (
        <CreditRuleCoin
          type={
            hasUpdates
              ? CreditUsageType.CONTACT_PROFILE_UPDATE
              : CreditUsageType.CONTACT_PROFILE_REVEAL
          }
          sx={SX.creditTag}
        />
      )}
      {!unlocked && !!unlockableItems.length && !loading && !hasUpdates && (
        <Button
          variant="contained"
          color="primary"
          size="xsmall"
          onClick={handleUnlock}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {unlockButtonTitle}
        </Button>
      )}
      {failed && !loading && (
        <Button
          variant="contained"
          color="primary"
          size="xsmall"
          onClick={handleUnlock}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          Retry
        </Button>
      )}
      {hasUpdates && !loading && (
        <Button
          variant="contained"
          color="primary"
          size="xsmall"
          onClick={handleUpdate}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          Update
        </Button>
      )}
      {loading && (
        <Button
          variant="contained"
          color="primary"
          size="xsmall"
          onMouseLeave={handleMouseLeave}
        >
          <CircularProgress size={18} sx={SX.loadingIcon} />
        </Button>
      )}
    </Styled.Wrapper>
  );
});

UnlockProfileDetails.displayName = 'UnlockProfileDetails';
